import {helpers, required} from "@vuelidate/validators";

export class ConsumerComplaintHealthPlanModel {
    constructor(data = {}) {
        this.healthPlanId = data.healthPlanId ?? null;
        this.complaintId = data.complaintId ?? null;
        this.healthInsuranceCompany = data.healthInsuranceCompany ?? '';
        this.otherHmoName = data.otherHmoName ?? '';
        this.patientInsuranceId = data.patientInsuranceId ?? '';
        this.typeOfCoverage = data.typeOfCoverage ?? '';
        this.otherTypeOfCoverage = data.otherTypeOfCoverage ?? '';
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    static getValidationRules() {
        return {
            healthInsuranceCompany: {required: helpers.withMessage('Consumer Complaint - Health Insurance Company is required', required)},
            patientInsuranceId: {required: helpers.withMessage('Consumer Complaint - Patient Insurance ID is required', required)}
        };
    }
}
